<template>
  <a-space>
    <template v-for="item in activeBtnArr">
      <template v-if="!item.componentName">
        <a
          v-if="!item.popconfirm"
          href="javascript:void(0);"
          size="small"
          type="link"
          :style="item.style"
          :loading="item.loading"
          @click.stop="item.fn(record)"
          >{{ item.label }}</a
        >
        <a-popconfirm
          v-else
          :title="item.popconfirm"
          placement="bottomRight"
          @confirm="item.fn(record)"
          class="append-to-table"
        >
          <a
            href="javascript:void(0);"
            size="small"
            type="link"
            :style="item.style"
            :loading="item.loading"
            >{{ item.label }}</a
          >
        </a-popconfirm>
      </template>

      <component
        v-else
        :is="item.componentName"
        v-bind="item.config(record)"
        @refresh="refresh"
      ></component>
    </template>

    <a-dropdown
      v-if="moreBtnArr.length > 0"
      :placement="'bottomRight'"
      :getPopupContainer="getContainer"
    >
      <div class="trigger-icon">
        <svg-icon icon-class="morebtn" size="12" />
      </div>
      <template #overlay>
        <a-menu class="btn-menu">
          <a-menu-item v-for="item in moreBtnArr">
            <template v-if="!item.componentName">
              <a
                v-if="!item.popconfirm"
                href="javascript:void(0);"
                size="small"
                type="link"
                :style="item.style"
                :loading="item.loading"
                @click.stop="item.fn(record)"
                >{{ item.label }}</a
              >
              <a-popconfirm
                v-else
                :title="item.popconfirm"
                placement="bottomRight"
                @confirm="item.fn(record)"
                class="append-to-table"
              >
                <a
                  href="javascript:void(0);"
                  size="small"
                  type="link"
                  :style="item.style"
                  :loading="item.loading"
                  >{{ item.label }}</a
                >
              </a-popconfirm>
            </template>

            <component
              v-else
              :is="item.componentName"
              v-bind="item.config(record)"
              @refresh="refresh"
            ></component>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <div v-else style="width: 12px"></div>
  </a-space>

  <a-modal
    :confirmLoading="loading"
    v-model:visible="visible"
    :centered="true"
    @ok="handleOk(currentAction)"
  >
    <template #title>
      <h4 class="flow-model-title">{{ modelMap.get(currentAction)?.title }}</h4>
      <span class="flow-model-subtitle">{{ modelMap.get(currentAction)?.subtitle }}</span>
    </template>
    <div class="flow-model__subtitle mt14" v-if="currentAction == 'delete'">
      当前审批状态：{{ record?.flowStatusName }}
    </div>
    <div class="flow-model__subtitle" v-if="currentAction == 'delete'">删除原因</div>
    <a-textarea
      show-count
      v-model:value="approvalContent"
      :placeholder="'请输入' + modelMap.get(currentAction)?.title + '，最多200字'"
      :auto-size="{ minRows: 3 }"
      :maxlength="200"
      allowClear
    />
  </a-modal>
</template>

<script lang="ts">
import { type Ref, computed, defineComponent, ref, toRefs, reactive, createVNode } from "vue";
import { Modal, message } from "ant-design-vue";
import _ from "lodash";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import { ApprovalFlowService } from "@/components/approval-table-flow-btn/approval-flow.service";
import { useFlowHandle } from "./useFlowHandle";
import { getCurrentUserId } from "@/utils";
import { VoidBtnModuleArr } from "./flow-btn.constant";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  isGlobal: true,
  name: "TableFlowBtnNew",
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
    },
    api: {
      type: String,
    },
    queryRef: {
      type: Object,
      default: () => {
        return {};
      },
    },
    record: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /**
     * eventName：
     * editPath:编辑路由
     * viewPath:详情路由
     * examineAccess:流程权限表示
     * editAccess:编辑权限表示
     * deleteAccess:删除权限表示
     * keyId？:详情、编辑 后缀
     */
    flowConfig: {
      type: Object,
      default: () => {
        return {};
      },
    },
    bizType: {
      type: String,
      default: "",
    },
    bizNameKey: {
      // 当前模块name的key值
      type: String,
      default: "name",
    },
    operationExternalData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    flowStatusTab: {
      // 当前tab的值
      type: String,
      default: "all",
    },
    recycleBinConfig: {
      type: Object,
      default: () => {
        return {};
      },
    },
    statusKey: {
      // 当前tab的值
      type: String,
      default: "status",
    },
    flowStatusKey: {
      // 当前tab的值
      type: String,
      default: "flowStatus",
    },
    noFlow: {
      type: Boolean,
      default: false,
    },
    other:{
      type:Function,
    },
    oldVoid: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["refresh"],
  setup(props, { emit, slots }) {
    const router = useRouter();
    const store = useStore();
    const state = reactive(<
      {
        approvalContent: string;
        loading: boolean;
        visible: boolean;
        currentUserId: string;
        modelMap: Map<String, { title: string; action: string; subtitle: string }>;
        currentAction: string;
      }
    >{
      approvalContent: "",
      loading: false,
      visible: false,
      currentUserId: getCurrentUserId(),
      modelMap: new Map([
        ["delete", { title: "删除", action: "删除" }],
        ["agree", { title: "审批意见", action: "同意", subtitle: "" }],
        ["reject", { title: "审批意见", action: "拒绝", subtitle: "" }],
        ["void", { title: "添加作废原因", action: "作废（必填）", subtitle: "当前操作：作废" }],
      ]),
      currentAction: "",
    });
    const {
      submitBtn,
      cancelBtn,
      voidBtn,
      deleteCompleteBtn,
      deleteBtn,
      visibleBtnByStatus,
      recycleBtn,
    } = useFlowHandle();
    const editRow = (item?) => {
       router.push(props.flowConfig.editPath + props.record[props.flowConfig.keyId ?? "id"]);
       if (window.self !== window.top) {
         window.parent.postMessage({ type: 'setShowCard', data: false }, '*');
        }
    };
    const submitRow = async (item?) => {
      if ( props.bizType == "completion_acceptance_examine") {
        Modal.confirm({
          title: "提示",
          icon: createVNode(ExclamationCircleOutlined),
          content: "竣工验收会导致整个项目流程完结，请谨慎操作！",
          okText: "确定",
          okType: "primary",
          cancelText: "取消",
         async onOk() {
          await submitBtn(props.record.id, props.bizType, props.record[props.bizNameKey]);
          refresh();
          },
          onCancel() {
            // console.log("Cancel");
          },
        });
      } else {
        await submitBtn(props.record.id, props.bizType, props.record[props.bizNameKey]);
      refresh();
      }
     
    };
    const revokeRow = async (item?) => {
      Modal.confirm({
        title: "提示",
        icon: createVNode(ExclamationCircleOutlined),
        content: "确定执行撤销？",
        okText: "确定",
        okType: "primary",
        centered: true,
        cancelText: "取消",
        onOk: async () => {
          await cancelBtn(props.record.id, props.bizType);
          refresh();
        },
        onCancel() {
          // console.log("Cancel");
        },
      });
    };
    const handleRow = (item?) => {
      router.push(props.flowConfig.viewPath + props.record[props.flowConfig.keyId ?? "id"]);
    };
    const voidRow = async (item?) => {
      state.currentAction = "void";
      state.visible = true;
      state.approvalContent = "";
    };
    const recycleRow = async (item?) => {
      // state.currentAction = "void";
      // state.visible = true;
      // state.approvalContent = "";
      await recycleBtn(props.record.id, props.bizType);
      refresh();
      // Modal.confirm({
      //   title: "正在进行恢复操作, 是否继续?",
      //   icon: createVNode(ExclamationCircleOutlined),
      //   content: "请谨慎操作！",
      //   okText: "确定",
      //   centered: true,
      //   okType: "primary",
      //   cancelText: "取消",
      //   onOk: async () => {
      //     await recycleBtn(props.record.id, props.bizType);
      //     refresh();
      //   },
      //   onCancel() {
      //     // console.log("Cancel");
      //   },
      // });
    };
    const handleVoidOk = async () => {
      if (!state.approvalContent) {
        message.warning("请填写作废原因");
        return;
      }
      state.loading = true;

      await voidBtn(
        props.record.id,
        props.bizType,
        props.record[props.bizNameKey],
        state.approvalContent,
        props.oldVoid
      );
      state.loading = false;

      refresh();

      state.visible = false;
    };
    const deleteRow = (item?) => {
      state.currentAction = "delete";
      state.visible = true;
      state.approvalContent = "";
    };
    const deleteCompleteRow = async (item?) => {
      Modal.confirm({
        title: "警告",
        icon: createVNode(ExclamationCircleOutlined),
        content: "彻底删除后将无法恢复，请谨慎操作！",
        okText: "确定",
        centered: true,
        okType: "primary",
        cancelText: "取消",
        onOk: async () => {
          await deleteCompleteBtn([props.record.id], props.bizType);
          refresh();
        },
        onCancel() {
          // console.log("Cancel");
        },
      });
    };
    const handleDeleteOk = async () => {
      if (!state.approvalContent) {
        message.warning("请填写删除原因");
        return;
      }
      state.loading = true;

      await deleteBtn(props.record.id, props.bizType, state.approvalContent);
      state.loading = false;

      refresh();

      state.visible = false;
    };
    const editPrem = computed(() => {
      return (
        visibleBtnByStatus(props.bizType, props.record[props.statusKey],props.other,props.record) &&
        !!store.state.user.buttons[props.flowConfig.editAccess]&&!props.noFlow
      );
    });
    const deletePrem = computed(() => {
      return !!store.state.user.buttons[props.flowConfig.deleteAccess]&&!props.noFlow;
    });
    const recyclePrem = computed(() => {
      return !!store.state.user.buttons[props.recycleBinConfig.recoverPremKey]&&!props.noFlow;
    });
    const deleteCompletePrem = computed(() => {
      return !!store.state.user.buttons[props.recycleBinConfig.deletePremKey]&&!props.noFlow;
    });

    const flowPrem = computed(() => {
      return (
        visibleBtnByStatus(props.bizType, props.record[props.statusKey],props.other,props.record) &&
        !!store.state.user.buttons[props.flowConfig.examineAccess]&&!props.noFlow
      );
    });
    const btnMap = new Map([
      [
        "edit",
        {
          label: "编辑",
          disabled: (row) => false,
          visible: (row) => {
            return (
              editPrem.value &&
              row.createBy === state.currentUserId &&
              (row.flowStatus === "dtj" || row.flowStatus === "ycx" || row.flowStatus === "spbtg")
            );
          },
          loading: (row) => false,
          premKey: "",
          fn: editRow,
        },
      ],
      [
        "submit",
        {
          label: "提交审批",
          disabled: (row) => false,
          loading: (row) => false,
          visible: (row) => {
            return (
              flowPrem.value &&
              row.createBy === state.currentUserId &&
              (row.flowStatus === "dtj" || row.flowStatus === "ycx" || row.flowStatus === "spbtg")
            );
          },
          fn: submitRow,
        },
      ],
      [
        "revoke",
        {
          label: "撤销",
          disabled: (row) => false,
          loading: (row) => false,
          visible: (row) => {
            return (
              flowPrem.value && row.flowStatus === "spz" && row.createBy == state.currentUserId && row?.isChanging != 1
            );
          },
          fn: revokeRow,
        },
      ],
      [
        "handle",
        {
          label: "立即审批",
          disabled: (row) => false,
          loading: (row) => false,
          visible: (row) => {
            return (
              flowPrem.value &&
              row.flowStatus === "spz" &&
              row.auditUsers?.includes(state.currentUserId)
            );
          },
          fn: handleRow,
        },
      ],
      [
        "void",
        {
          label: "作废",
          disabled: (row) => false,
          loading: (row) => false,
          style: { color: "red" },
          visible: (row) => {
            return (
              flowPrem.value &&
              row.createBy == state.currentUserId &&
              (VoidBtnModuleArr?.includes(props.bizType) &&
              (row["validStatus"] &&
              row["validStatus"] != "yzf" &&
              row.flowStatus === "sptg")||(props.oldVoid&&((row.flowStatus === "sptg" && row.flowType === "tjsp" ) ||
          (row.flowStatus === "spbtg" && row.flowType === "yzf") ||
          (row.flowStatus === "ycx" && row.flowType === "yzf"))))
            );
          },
          fn: voidRow,
        },
      ],
      [
        "delete",
        {
          label: "删除",
          disabled: (row) => false,
          loading: (row) => false,
          style: { color: "red" },
          visible: (row) => {
            return (
              deletePrem.value &&
              row.createBy === state.currentUserId &&
              (row.flowStatus === "dtj" || row.flowStatus === "ycx")
            );
          },
          fn: deleteRow,
        },
      ],
      [
        "recover",
        {
          label: "恢复",
          disabled: (row) => false,
          loading: (row) => false,
          isRecycled: true,
          visible: (row) => {
            return recyclePrem.value && row.createBy === state.currentUserId;
          },
          fn: recycleRow,
        },
      ],
      [
        "delete-completely",
        {
          label: "彻底删除",
          disabled: (row) => false,
          loading: (row) => false,
          isRecycled: true,
          visible: (row) => {
            return deleteCompletePrem.value && row.createBy === state.currentUserId;
          },
          fn: deleteCompleteRow,
        },
      ],
    ]);
    const btnArr = computed(() => {
      //permValue
      let b = [...props.operationExternalData].filter((x: any) => {
        // console.log('buttonssss', store.state.user.buttons);
        // console.log('x.visible(props.record)', x['permValue']);
        
        return (
          x.visible(props.record) &&
          (!x["permValue"] || !!store.state.user.buttons[x["permValue"]]) &&
          ((props.flowStatusTab == "hsz" && x.isRecycled) ||
            (props.flowStatusTab != "hsz" && !x.isRecycled))
        );
      });
      let a: any = [...btnMap.values()].filter((x: any) => {
        props.record["flowStatus"] = props.record["flowStatus"]
          ? props.record["flowStatus"]
          : props.record[props.flowStatusKey];
        return (
          x.visible(props.record) &&
          ((props.flowStatusTab == "hsz" && x.isRecycled) ||
            (props.flowStatusTab != "hsz" && !x.isRecycled))
        );
      });
      return [...b, ...a];
    });
    const activeBtnArr: Ref<
      Array<{
        popconfirm: any;
        style: any;
        label: String;
        disabled: boolean | Function;
        visible: boolean | Function;
        loading: boolean | Function;
        fn: Function;
        premKey: String;
        componentName?: any;
        config?: any;
      }>
    > = computed(() => {
      return btnArr.value && btnArr.value.slice(0, 2);
    });
    const moreBtnArr: Ref<
      Array<{
        popconfirm: any;
        style: any;
        label: String;
        disabled: boolean;
        visible: boolean;
        loading: boolean;
        fn: Function;
        premKey: String;
        componentName?: any;
        config?: any;
      }>
    > = computed(() => {
      let arr: any = [];
      return btnArr.value && btnArr.value.slice(2);
    });
    const getContainer = () => {
      return document.body;
    };
    const refresh = () => {
      emit("refresh");
    };
    const handleOk = async (type) => {
      switch (type) {
        case "delete":
          await handleDeleteOk();
          break;
        case "reject":
          break;
        case "void":
          await handleVoidOk();
          break;

        default:
          break;
      }
    };
    return {
      ...toRefs(state),
      btnMap,
      activeBtnArr,
      moreBtnArr,
      getContainer,
      refresh,
      handleVoidOk,
      handleOk,
    };
  },
});
</script>

<style scoped>
.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:hover,
.ant-btn-primary[disabled]:focus,
.ant-btn-primary[disabled]:active {
  color: #fff;
  border-color: #579aff;
  background: #579aff;
}
.ant-btn-dangerous[disabled],
.ant-btn-dangerous[disabled]:hover,
.ant-btn-dangerous[disabled]:focus,
.ant-btn-dangerous[disabled]:active {
  color: #fff;
  border-color: #ff7875 !important;
  background-color: #ff7875 !important;
}
.flow-model-title {
  margin-bottom: 0;
  font-weight: 600;

  display: inline-block;
}
.flow-model__subtitle {
}
.mt14 {
  margin-top: -14px;
}
.flow-model-subtitle {
  font-size: 14px;
  padding-left: 10px;
}
</style>
